import React, { memo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { useScreenInit } from '../useScreenInit';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
const EVENT_DETAILS: Record<string, any> = {
  birthdays: {
    name: 'Birthdays',
    tagline: 'Celebrate Life',
    // s, Milestones, ',: hero,
    hero: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?q=80&w=2064&auto=format&fit=crop',
    description: 'From intimate gatherings to grand celebrations, we transform birthday parties into unforgettable experiences. Our curated collection of rentals and expert styling ensure every detail reflects the personality and joy of the guest of honor.',
    features: ['Custom theme development and color coordination', 'Age-appropriate décor and styling', 'Premium table settings and linens', 'Balloon installations and backdrops', 'Specialty furniture and lounge areas', 'Complete setup and breakdown services'],
    gallery: ['https://images.unsplash.com/photo-1530103862676-de8c9debad1d?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?q=80&w=2011&auto=format&fit=crop', 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2070&auto=format&fit=crop']
  },
  'baby-showers': {
    name: 'Baby Showers',
    tagline: 'Welcome New Beginnings',
    hero: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=2070&auto=format&fit=crop',
    description: 'Celebrate the arrival of a new life with our elegant baby shower rentals. We specialize in creating soft, sophisticated atmospheres that honor this precious moment with style and grace.',
    features: ['Soft, gender-neutral or themed color palettes', 'Elegant table settings and centerpieces', 'Custom signage and welcome displays', 'Specialty seating and lounge furniture', 'Balloon garlands and floral arrangements', 'Professional delivery and styling'],
    gallery: ['https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=2074&auto=format&fit=crop', 'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?q=80&w=2070&auto=format&fit=crop']
  },
  'bridal-showers': {
    name: 'Bridal Showers',
    tagline: 'Celebrate Love & Friendship',
    hero: 'https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?q=80&w=2070&auto=format&fit=crop',
    description: 'Honor the bride-to-be with a beautifully styled bridal shower. Our premium rentals and expert design create an intimate, elegant setting that celebrates friendship and the journey to the altar.',
    features: ['Romantic and sophisticated styling', 'Premium linens and table settings', 'Specialty seating and lounge areas', 'Custom backdrops and photo opportunities', 'Elegant centerpieces and florals', 'Complete event coordination'],
    gallery: ['https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=2074&auto=format&fit=crop', 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop']
  },
  'weddings-receptions': {
    name: 'Weddings & Receptions',
    tagline: 'Your Dream Day, Perfectly Styled',
    hero: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2070&auto=format&fit=crop',
    description: 'From ceremony to reception, we provide the finest rentals and styling to make your wedding day truly unforgettable. Our comprehensive collection ensures every detail reflects your unique love story.',
    features: ['Ceremony and reception styling', 'Premium furniture and lounge areas', 'Elegant table settings and linens', 'Custom backdrops and installations', 'Lighting and atmospheric décor', 'Full-service coordination and setup'],
    gallery: ['https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=2074&auto=format&fit=crop', 'https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?q=80&w=2069&auto=format&fit=crop']
  },
  graduations: {
    name: 'Graduations',
    tagline: 'Celebrate Academic Achievement',
    hero: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?q=80&w=2070&auto=format&fit=crop',
    description: 'Mark this significant milestone with a celebration that honors hard work and achievement. Our graduation event rentals create a festive, sophisticated atmosphere for family and friends to gather.',
    features: ['School colors and custom theming', 'Premium table settings and linens', 'Photo backdrops and display areas', 'Specialty seating and lounge furniture', 'Balloon installations and signage', 'Professional setup and breakdown'],
    gallery: ['https://images.unsplash.com/photo-1523580494863-6f3031224c94?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1541339907198-e08756dee81c?q=80&w=2070&auto=format&fit=crop']
  },
  'corporate-events': {
    name: 'Corporate Events',
    tagline: 'Professional Excellence',
    hero: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop',
    description: 'Elevate your corporate gatherings with our premium event rentals. From conferences to galas, we provide sophisticated styling that reflects your brand',
    // s, professionalism, and, vision, : ., ',: features,
    features: ['Brand-aligned color schemes and styling', 'Modern furniture and lounge areas', 'Professional table settings', 'Custom signage and displays', 'Stage and presentation setups', 'Full-service event coordination'],
    gallery: ['https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop', 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2162&auto=format&fit=crop', 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?q=80&w=2070&auto=format&fit=crop']
  },
  'private-dinners': {
    name: 'Private Dinners',
    tagline: 'Intimate Elegance',
    hero: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974&auto=format&fit=crop',
    description: 'Create an unforgettable dining experience with our curated collection of premium table settings and atmospheric décor. Perfect for intimate gatherings and special occasions.',
    features: ['Elegant table settings and linens', 'Premium dinnerware and glassware', 'Atmospheric lighting and candles', 'Custom centerpieces and florals', 'Specialty seating arrangements', 'Professional styling and setup'],
    gallery: ['https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974&auto=format&fit=crop', 'https://images.unsplash.com/photo-1510076857177-7470076d4098?q=80&w=2072&auto=format&fit=crop', 'https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?q=80&w=2012&auto=format&fit=crop']
  },
  'vendor-events-pop-ups': {
    name: 'Vendor Events & Pop-Ups',
    tagline: 'Showcase Your Brand',
    hero: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=80&w=2070&auto=format&fit=crop',
    description: 'Make your brand stand out with our versatile event rentals designed for vendor events and pop-up experiences. We provide the infrastructure and style to create memorable brand activations.',
    features: ['Custom display and booth setups', 'Modern furniture and seating', 'Branded signage and backdrops', 'Lighting and atmospheric elements', 'Flexible configurations', 'Quick setup and breakdown services'],
    gallery: ['https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?q=80&w=2162&auto=format&fit=crop', 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?q=80&w=2070&auto=format&fit=crop']
  }
};
export function EventDetail() {
  useScreenInit();
  const {
    eventSlug
  } = useParams<{
    eventSlug: string;
  }>();
  const event = eventSlug ? EVENT_DETAILS[eventSlug] : null;
  if (!event) {
    return <div className="min-h-screen bg-white font-sans flex items-center justify-center" data-id="element-340">
        <TopBar data-id="element-341" />
        <Navbar data-id="element-342" />
        <div className="text-center" data-id="element-343">
          <h1 className="font-serif text-4xl text-gray-900 mb-4" data-id="element-344">
            Event Not Found
          </h1>
          <Link to="/" className="text-[#b22222] underline" data-id="element-345">
            Return Home
          </Link>
        </div>
      </div>;
  }
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.8
  }} className="min-h-screen bg-white font-sans selection:bg-[#b22222] selection:text-white" data-id="element-346">
      <TopBar data-id="element-347" />
      <Navbar data-id="element-348" />

      <main data-id="element-349">
        {/* Hero Section */}
        <section className="relative h-[50vh] flex items-center justify-center bg-black overflow-hidden" data-id="element-350">
          <div className="absolute inset-0 bg-cover bg-center opacity-50" style={{
          backgroundImage: `url("${event.hero}")`
        }} data-id="element-351" />
          <div className="relative text-center text-white z-10 px-6" data-id="element-352">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-[10px] uppercase tracking-[0.4em] font-bold mb-4 block" data-id="element-353">
              {event.tagline}
            </motion.span>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="font-serif text-5xl md:text-7xl italic" data-id="element-354">
              {event.name}
            </motion.h1>
          </div>
          <Link to="/" className="absolute top-8 left-8 text-white hover:text-[#b22222] transition-colors flex items-center gap-2 text-sm uppercase tracking-widest font-bold" data-id="element-355">
            <ArrowLeft size={16} data-id="element-356" /> Back
          </Link>
        </section>

        {/* Description Section */}
        <section className="py-24" data-id="element-357">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-358">
            <div className="max-w-[1440px] mx-auto px-6" data-id="element-359">
              <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-360">
                <h2 className="font-serif text-3xl md:text-4xl text-gray-900" data-id="element-361">
                  What We Offer
                </h2>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-362">
                  {event.description}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features Grid */}
        <section className="py-24 bg-gray-50" data-id="element-363">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-364">
            <div className="max-w-[1440px] mx-auto px-6" data-id="element-365">
              <div className="max-w-4xl mx-auto" data-id="element-366">
                <h3 className="font-serif text-2xl text-gray-900 mb-12 text-center" data-id="element-367">
                  Included Services
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-368">
                  {event.features.map((feature: string, index: number) => <div key={index} className="flex items-start gap-4" data-id="element-369">
                      <CheckCircle2 size={20} className="text-[#b22222] flex-shrink-0 mt-1" data-id="element-370" />
                      <p className="text-gray-600" data-id="element-371">{feature}</p>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section className="py-24" data-id="element-372">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-373">
            <div className="max-w-[1440px] mx-auto px-6" data-id="element-374">
              <h3 className="font-serif text-2xl text-gray-900 mb-12 text-center" data-id="element-375">
                Inspiration Gallery
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-376">
                {event.gallery.map((img: string, index: number) => <motion.div key={index} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="aspect-[4/5] overflow-hidden" data-id="element-377">
                    <img src={img} alt={`${event.name} ${index + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-378" />
                  </motion.div>)}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-24 bg-black text-white text-center" data-id="element-379">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-380">
            <div className="max-w-4xl mx-auto px-6" data-id="element-381">
              <h2 className="font-serif text-4xl md:text-5xl mb-8 italic" data-id="element-382">
                Ready to Plan Your {event.name}?
              </h2>
              <p className="text-gray-400 text-lg mb-12" data-id="element-383">
                Let's discuss how we can bring your vision to life with our
                premium rentals and expert styling.
              </p>
              <Link to="/contact" data-id="element-384">
                <button className="bg-white text-black px-12 py-5 text-xs font-bold uppercase tracking-widest hover:bg-[#b22222] hover:text-white transition-all duration-300" data-id="element-385">
                  Book a Consultation
                </button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-white py-12 border-t border-gray-100" data-id="element-386">
        <div className="mx-4 md:mx-[4.1rem]" data-id="element-387">
          <div className="max-w-[1440px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-388">
            <div className="flex flex-col items-center md:items-start leading-none" data-id="element-389">
              <span className="font-script text-3xl text-black" data-id="element-390">
                Chyne Designs
              </span>

              <span className="text-[8px] uppercase tracking-[0.2em] font-bold text-gray-400 mt-1" data-id="element-391">
                Elegant Events & Rentals LLC
              </span>
            </div>
            <div className="flex gap-8 text-[11px] font-bold uppercase tracking-widest text-gray-500" data-id="element-392">
              <a href="#" className="hover:text-black transition-colors" data-id="element-393">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-black transition-colors" data-id="element-394">
                Terms of Service
              </a>
              <a href="#" className="hover:text-black transition-colors" data-id="element-395">
                Contact
              </a>
            </div>

            <p className="text-[11px] text-gray-400" data-id="element-396">
              © 2026 Chyne Designs Elegant Events & Rentals LLC. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </motion.div>;
}